// src/pages/ApplicationChampionshipSeason/shared/steps/Step2Stages/KnockoutStagePanel.tsx
import { FunctionComponent } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { InfoCallout } from '../../components/InfoCallout';
import { KnockoutStageList } from './KnockoutStageList';

const PREFIX = 'pages.application_season.components.season_step2';

type KnockoutStagePanelProps = {
  isReadOnly?: boolean;
};

export const KnockoutStagePanel: FunctionComponent<KnockoutStagePanelProps> = ({
  isReadOnly = false,
}) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={5}>
      <InfoCallout>
        <Text as="span" fontWeight="bold">
          {t(`${PREFIX}.callouts.knockout_prefix`)}
        </Text>{' '}
        {t(`${PREFIX}.callouts.knockout_text`)}
      </InfoCallout>

      <KnockoutStageList
        addLabel={t(`${PREFIX}.actions.add_stage`)}
        isReadOnly={isReadOnly}
      />
    </Flex>
  );
};
